import { useQuery } from '@apollo/client'
import { GetUserActiveMediumCartQuery } from 'gql'
import { useCancelCartMutation } from 'gql/cart'
import { GET_USER_ACTIVE_ARTWORK_PACKAGE_CART } from 'gql/cart/queries'

const useCartWidget = () => {
  const { data: cart, loading: cartLoading } = useQuery<GetUserActiveMediumCartQuery>(
    GET_USER_ACTIVE_ARTWORK_PACKAGE_CART,
    { fetchPolicy: 'network-only' }
  )

  const {
    error: cancelCartError,
    loading: cancelCartLoading,
    mutate: cancelCart,
  } = useCancelCartMutation({
    notifyOnNetworkStatusChange: true,
    refetchQueries: [GET_USER_ACTIVE_ARTWORK_PACKAGE_CART],
  })

  return {
    cart: {
      cartLoading,
      isCart: !!cart?.findCart,
      quantity: cart?.findCart?.items[0]?.quantity,
      price: cart?.findCart?.items[0]?.price,
      artwork: cart?.findCart?.items[0]?.artwork,
      isPackage: !!cart?.findCart?.items[0]?.package,
    },
    cancelCartError,
    cancelCartLoading,
    cancelCart: () => cancelCart({ cartId: cart?.findCart?.id }),
  }
}

export default useCartWidget
